<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import CustomList from "../../compositions/CustomList.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import config from "../../config.js";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
})

const listRef = ref();
const isListShow = ref(false);
const isLoading = ref(false);
const documentClick = () => {
  isListShow.value = !isListShow.value;
}
const documentClose = () => {
  isListShow.value = false;
}
const documentReset = () => {
  isClosing.value = true;
}
const {element,isClosing,clickOutside} = CustomEvent(documentClose)

onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});
onMounted(() => {
  window.addEventListener('click', clickOutside);
});
</script>

<style scoped>
</style>
<template>
<div ref="element">
  <!-- Notifications -->
  <button type="button" data-dropdown-toggle="notification-dropdown" class="inline-flex relative items-center p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100" @click="documentClick">
    <span class="sr-only">資料をダウンロードする</span>
    <!-- Bell icon -->
    <img class="w-6 h-6" src="../../../public/images/icon/btn_document.svg" alt="notice">
  </button>
  <!-- Dropdown menu -->
  <div v-show="isListShow" class="absolute mb-4 max-w-sm text-base list-none bg-white rounded divide-y divide-gray-100 shadow-lg">
    <custom-list
      ref="listRef"
      :api-url="apis.document_list"
      :reset="documentReset"
    >
    <template v-slot:item="slotProps">
      <div>
        <a :href="slotProps.item.document_file_url" _target="blank" class="underline text-blue-500">{{ slotProps.item.document_name }}</a>
      </div>
    </template>
    </custom-list>
  </div>
</div>
</template>

